import type { Tuple } from '@nextgen-web-framework/core';
import {
  CreateContact,
  ContactType,
  ContactInformationFormType,
  ProfileInformationType,
  AlternativeContactType,
  AlternatePhoneType,
  OwnerType,
  AddressContactType,
} from '@commerce-profile-webcomponents/sdk';

export const ShippingAddressIntialValue: CreateContact = {
  recipientFirstName: '',
  recipientLastName: '',
  phone: '',
  addrLineOne: '',
  addrLineTwo: '',
  contactNickname: '',
  postalCode: '',
  city: '',
  state: '',
  deliveryInstructions: '',
  contactType: ContactType.Shipping,
  isDefault: false,
};
export const ContactInformationIntialValue: ContactInformationFormType = {
  firstName: '',
  lastName: '',
  email: '',
};

export const ProfileInitialValue: ProfileInformationType = {
  mailingAddress: {
    contactType: ContactType.Mailing,
  },
  billingAddress: {
    contactType: ContactType.Billing,
  },
  taxAddress: {
    contactType: ContactType.Billing,
  },
  useAsBilling: true,
  useAsMailing: true,
  profileData: {
    firstName: '',
    lastName: '',
    titleSalutation: '',
    gender: '',
    maritalStatus: '',
    birthDate: '',
    citizenship: '',
    idNumber: '',
    email: '',
    phone: '',
    dialCode: '',
    alternativePhone: [],
  },
};

export const AlternativeContactInitialValue: AlternativeContactType = {
  id: 0,
  type: AlternatePhoneType.Home,
  dialCode: '',
  number: '',
};

export const AddressInitialValue = (
  contactType: ContactType,
  accountNum: string,
  ownerType: OwnerType = OwnerType.Profile,
  ownerId?: string,
): AddressContactType =>
  ({
    contactType: contactType,
    ownerType: ownerType,
    addrLineOne: '',
    addrLineTwo: '',
    state: '',
    city: '',
    postalCode: '',
    contactId: '',
    accountNumber: parseInt(accountNum ?? '0'),
    ownerId: ownerId || accountNum,
    isDefault: false,
    province: '',
    provinceCode: '',
    district: '',
  }) as AddressContactType;
interface LoginState {
  headers: Tuple;
  redirectUri: string;
  loginUrl?: string;
  amwayLang?: string;
}
export const getLoginProps = (currentLocale: string, sourceUrl: string) => {
  const tuples = ApiConfigService.getTuples();
  const configs = ConfigService.getConfigs();
  let postAuthUrl = '';
  if (typeof window !== 'undefined') {
    const loginState: LoginState = {
      redirectUri:
        typeof sourceUrl !== 'undefined' && sourceUrl?.length !== 0
          ? sourceUrl
          : `${configs.NEXT_PUBLIC_WEB_BASE_PATH}`,
      headers: tuples,
      amwayLang: currentLocale,
    };

    if (configs.NEXT_PUBLIC_LOGIN_URL) {
      loginState.loginUrl = configs.NEXT_PUBLIC_LOGIN_URL as string;
    }
    postAuthUrl = btoa(JSON.stringify(loginState));
  }
  return {
    scope: 'openid',
    state: postAuthUrl,
    countryIso: tuples['X-Amway-Country'],
    redirectUri: configs.NEXT_PUBLIC_OIDC_URL ? `${configs.NEXT_PUBLIC_OIDC_URL}` : '',
  };
};

export const convertImageToBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
